import { render, staticRenderFns } from "./uploadField.vue?vue&type=template&id=d321b4e6&scoped=true&"
import script from "./uploadField.vue?vue&type=script&lang=js&"
export * from "./uploadField.vue?vue&type=script&lang=js&"
import style0 from "./uploadField.vue?vue&type=style&index=0&id=d321b4e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d321b4e6",
  null
  
)

export default component.exports